import React from 'react'
import Review from '../../components/Host/Review'

function SpotDetails() {
  return (
        <Review/>
  )
}

export default SpotDetails